import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import InputField from '../../FormFields/InputField';
import { Grid, Typography, Paper, Box } from '@mui/material';

export default function ResourceDetailsForm(props) {
  const { values, setFieldValue } = useFormikContext();
  const {
    formField: { vehicleType, domain, propertyNumber }
  } = props;

  const [vehicleTypeValue, setVehicleTypeValue] = useState('');

  useEffect(() => {
    const handleInputChange = async (event) => {
      const { value } = event.target;
      if (!value) return;

      try {
        let url = new URL(`${import.meta.env.VITE_API_URL}/debit/resource`);
        url.search = new URLSearchParams({
          resource: values.resource,
          resourceNumber: value
        });

        const response = await fetch(url.href);
        const data = await response.json();

        if (data.exists) {
          if (values.resource === 'Rodado') {
            const rolledType = parseInt(data.rolled_type);
            let selectedVehicleType = rolledType === 30 ? 'Moto' : rolledType === 60 ? 'Automotor' : '';
            setVehicleTypeValue(selectedVehicleType);
            setFieldValue(vehicleType.name, selectedVehicleType);
          }

        } else {
          setVehicleTypeValue('');
          setFieldValue(vehicleType.name, '');
        }
      } catch (error) {
        console.error("Error al realizar la solicitud:", error);
      }
    };

    const inputField = document.getElementById(values.resource === 'Rodado' ? domain.name : propertyNumber.name);
    if (inputField) {
      inputField.addEventListener('input', handleInputChange);
    }

    return () => {
      if (inputField) {
        inputField.removeEventListener('input', handleInputChange);
      }
    };
  }, [values.resource, domain.name, propertyNumber.name, setFieldValue, vehicleType.name]);

  useEffect(() => {
    if (values.resource !== 'Rodado') {
      setVehicleTypeValue('');
      setFieldValue(vehicleType.name, '');
      setFieldValue(domain.name, '');
    }
  }, [values.resource, setFieldValue, vehicleType.name, domain.name]);

  return (
    <React.Fragment>
      <Box my={3}>
        <Paper elevation={2} square>
          <Typography component="div" variant="subtitle2" gutterBottom>
            <Box p={1} fontWeight={550}>
              Para adherirse al débito automático complete el formulario. Los datos tienen el carácter de declaración jurada.
            </Box>
          </Typography>
        </Paper>
      </Box>
      <Typography variant="h6" gutterBottom>
        Datos del {`${values.resource}`}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <InputField
            maxSize={8}
            id={values.resource === 'Rodado' ? domain.name : propertyNumber.name}
            name={values.resource === 'Rodado' ? domain.name : propertyNumber.name}
            label={values.resource === 'Rodado' ? domain.label : propertyNumber.label}
            fullWidth
          />
        </Grid>
        {values.resource === 'Rodado' && (
          <Grid item xs={12} sm={6}>
            <InputField
              name={vehicleType.name}
              label="Tipo de Rodado"
              value={vehicleTypeValue}
              fullWidth
              disabled
            />
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
}
